import { render, staticRenderFns } from "./batch-cell.vue?vue&type=template&id=65076f5e"
import script from "./batch-cell.vue?vue&type=script&setup=true&lang=js"
export * from "./batch-cell.vue?vue&type=script&setup=true&lang=js"
import style0 from "./batch-cell.vue?vue&type=style&index=0&id=65076f5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports